import storedModels from '@/models/StoredModels';
import { isArray, isObject, forEach } from 'lodash';
// @ts-ignore
import Compression from 'lz-string';
var addModelConstructors = function (object) {
    var packedObject = null;
    if (isArray(object)) {
        packedObject = forEach(object, function (value, key) {
            if (isObject(value)) {
                object[key] = addModelConstructors(value);
            }
        });
    }
    if (isObject(object)) {
        packedObject = forEach(object, function (value, key) {
            if (isArray(value)) {
                object[key] = addModelConstructors(value);
            }
            if (isObject(value)) {
                var hasModel = object[key] && object[key].__mc;
                if (hasModel) {
                    object[key] = addModelConstructors(value);
                }
            }
        });
    }
    packedObject['hydrationStrategy'] = 'hydrateFromStore';
    return packedObject;
};
var createModel = function (object) {
    var modelName = object['__mc'];
    if (modelName) {
        object = new storedModels[modelName](object);
    }
    return object;
};
var instantiateModels = function (object) {
    var unpackedObject = null;
    if (isArray(object)) {
        unpackedObject = forEach(object, function (value, key) {
            if (isObject(value)) {
                object[key] = instantiateModels(value);
            }
        });
    }
    if (isObject(object)) {
        unpackedObject = forEach(object, function (value, key) {
            if (isArray(value)) {
                object[key] = instantiateModels(value);
            }
            if (isObject(value)) {
                var hasModel = object[key] && object[key].__mc;
                if (hasModel) {
                    object[key] = instantiateModels(value);
                }
            }
        });
    }
    unpackedObject = createModel(unpackedObject);
    return unpackedObject;
};
var packer = function (object) {
    var packedObject = addModelConstructors(object);
    packedObject = Compression.compress(JSON.stringify(packedObject));
    return packedObject;
};
var unpacker = function (packedObject) {
    var object;
    var unpackedObject = null;
    try {
        object = JSON.parse(Compression.decompress(packedObject));
        unpackedObject = instantiateModels(object);
    }
    catch (error) {
        console.error(error + " local storage data was corrupted, and is now being cleared.");
    }
    return unpackedObject;
};
var StoragePacker = /** @class */ (function () {
    function StoragePacker() {
    }
    StoragePacker.pack = function (object) {
        var packedObject = packer(object);
        return packedObject;
    };
    StoragePacker.unpack = function (object) {
        var unpackedObject = unpacker(object);
        return unpackedObject;
    };
    return StoragePacker;
}());
export default StoragePacker;



//////////////////
// WEBPACK FOOTER
// ./src/utils/StoragePacker.ts
// module id = null
// module chunks = 